import { render, staticRenderFns } from "./host-common-department.vue?vue&type=template&id=77b4ae24&scoped=true&"
import script from "./host-common-department.vue?vue&type=script&lang=js&"
export * from "./host-common-department.vue?vue&type=script&lang=js&"
import style0 from "./host-common-department.vue?vue&type=style&index=0&id=77b4ae24&scoped=true&lang=scss&"
import style1 from "./host-common-department.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4ae24",
  null
  
)

export default component.exports